
// import {
//   Box,
//   Button,
//   Card,
//   CardContent,
//   Checkbox,
//   Divider,
//   FormControl,
//   FormControlLabel,
//   Grid,
//   Paper,
//   Radio,
//   RadioGroup,
//   Typography,
// } from '@mui/material';
// import Modal from '@mui/material/Modal';
// import React, { useEffect, useState } from 'react';
// import { formatDate, StarSymbol } from '../../Style';
// import { Controller, useFieldArray, useForm } from 'react-hook-form';
// import { useNavigate, useLocation } from 'react-router-dom';
// import {
//   INSTANT_BOOKING_AIRPORT_DETAILS,
//   INSTANT_BOOKING_SUMMARY,
// } from '../../component/common/Routes/AppRoutes';
// import 'react-perfect-scrollbar/dist/css/styles.css';
// import CustomButton from '../../component/ui/FormFields/Button';
// import ControlledTextInputField from '../../component/ui/FormFields/ControlledTextInputField';
// import { selectCountryRequest } from '../../redux/Common/selectorAction';
// import { useDispatch, useSelector } from 'react-redux';

// import {
//   fetchBillingAddressesRequest,
//   resetBillingAddressState,
// } from '../../redux/BillingAddress/BillingAddressAction';
// import { resetBookingDetails } from '../../redux/Bookings/BookingAction';
// import { toast, ToastContainer } from 'react-toastify';
// import BookingAddAddressForm from '../Address/BookingBillingAddress';
// import * as actions from '../../redux/FamilyMembers/actions';
// import BookingAddFamilyMember from '../FamilyMembers/BookingAddFamilyMember';
// const Form2 = () => {
//   const location = useLocation();
//   const dispatch = useDispatch();
//   const form1Value = location.state?.form1Value || {};
//   const hasPorterService = [
//     form1Value?.departure_plan,
//     form1Value?.arrival_plan,
//     form1Value?.transit_plan,
//   ].some((plan) => plan?.label?.toLowerCase()?.includes('porter'));

//   const form2Value = location.state?.form2Value || {};
//   const form3Value = location.state?.form3Value || {};
//   const [open, setOpen] = React.useState(false);
//   const user = useSelector((state) => state.auth.user);
//   const [addressError, setAddressError] = useState(false);
//   const customerId = form1Value?.customer?.value;
//   const [familyMemberOpen, setFamilyMemberOpen] = React.useState(false);
//   const addFamilyMemberModalOpen = () => setFamilyMemberOpen(true);
//   const addFamilyMemberModalClose = () => {
//     setFamilyMemberOpen(false);
//     dispatch(
//       actions.fetchFamilyMembersRequest(
//         user?.customer_id || customerId || form1Value?.customerDetails?.id
//       )
//     );
//   };
//   const handleSelectAddress = (event) => {
//     setSelectedAddress(event.target.value);
//     setAddressError(false); // Clear error when user selects
//   };
//   const handleOpen = () => setOpen(true);
//   const handleClose = () => {
//     setOpen(false);
//     dispatch(
//       fetchBillingAddressesRequest(
//         user?.customer_id || customerId || form1Value?.customerDetails?.id
//       )
//     );
//   };

//   const [selectedAddress, setSelectedAddress] = useState('');
//   const [selectedMembers, setSelectedMembers] = useState([]);
//   const adultFamilyMember = selectedMembers?.filter((adult) => {
//     return adult?.age >= 12;
//   });
//   const infantFamilyMember = selectedMembers?.filter((infant) => {
//     return infant?.age < 2;
//   });
//   const childFamilyMember = selectedMembers?.filter((child) => {
//     return child?.age >= 2 && child?.age < 12;
//   });
//   const { familyMembers, loading, error } = useSelector(
//     (state) => state.familyMember
//   );
//   useEffect(() => {
//     setSelectedAddress(form2Value?.billing_address);
//     setSelectedMembers(form2Value?.family_members);
//   }, [form2Value?.billing_address]);
//   const {
//     formState: { errors },
//     control,
//     handleSubmit,
//     watch,
//     setValue,
//     clearErrors,
//   } = useForm({
//     defaultValues: {
//       no_of_adult: form2Value.no_of_adult || '',
//       no_of_child: form2Value.no_of_child || '',
//       no_of_infant: form2Value.no_of_infant || '',
//       no_of_service_required: form2Value.total_services || '1',
//       total_passengers: form2Value.total_passengers || '',

//       city: form2Value?.city
//         ? {
//             label: form2Value?.city?.label.replace('_', ' ').toUpperCase(),
//             value: form2Value?.city?.label,
//           }
//         : null,
//       state: form2Value?.state
//         ? {
//             label: form2Value?.state?.label.replace('_', ' ').toUpperCase(),
//             value: form2Value?.state?.label,
//           }
//         : null,
//       country: form2Value?.country
//         ? {
//             label: form2Value?.country?.label.replace('_', ' ').toUpperCase(),
//             value: form2Value?.country?.label,
//           }
//         : null,

//       notes: form2Value?.notes || '',
//       company_name: form2Value?.company_name || '',
//       gstin_number: form2Value?.gstin_number || '',
//       pincode: form2Value?.pincode || '',
//       address: form2Value?.address || '',
//       adults: form2Value?.adults || [
//         {
//           first_name: '',
//           last_name: '',
//           age: '',
//           phone: '',
//           gender_type: '',
//           country_code: ' ',
//           havePassport: false, // Passport switch field
//           passport_number: '', // Passport number field
//           aadhar_number: '',
//           nationality: '',
//           type: '3',
//         },
//       ],
//       children: form2Value.children || [
//         {
//           first_name: '',
//           last_name: '',
//           age: '',
//           country_code: ' ',
//           phone: '',
//           gender_type: '',
//           nationality: '',
//           havePassport: false, // Passport switch field
//           passport_number: '', // Passport number field
//           aadhar_number: '',
//           type: '2',
//         },
//       ], // Default fields for children
//       infants: form2Value.infants || [
//         {
//           first_name: '',
//           last_name: '',
//           age: '',
//           country_code: ' ',
//           phone: '',
//           type: '1',
//           gender_type: '',
//           nationality: '',
//           havePassport: false, // Passport switch field
//           passport_number: '', // Passport number field
//           aadhar_number: '',
//           type: '1',
//         },
//       ], // Default fields for infants
//     },
//   });

//   // address selector

//   useEffect(() => {
//     dispatch(selectCountryRequest());
//   }, []);

//   const formValue = watch();

//   const {
//     addresses = [],
//     loading: viewListLoading,
//     address: successMessage,
//   } = useSelector((state) => state.billingAddress);
//   const handleCheckboxChange = (member) => {
//     setSelectedMembers((prevSelected = []) => {
//       const isAlreadySelected = prevSelected.some((m) => m.id === member.id);

//       if (isAlreadySelected) {
//         return prevSelected.filter((m) => m.id !== member.id);
//       } else {
//         return [...prevSelected, member];
//       }
//     });
//   };
//   useEffect(() => {
//     dispatch(
//       fetchBillingAddressesRequest(
//         user.customer_id || customerId || form1Value?.customerDetails?.id
//       )
//     );
//     dispatch(
//       actions.fetchFamilyMembersRequest(
//         user.customer_id || customerId || form1Value?.customerDetails?.id
//       )
//     );

//     dispatch(resetBillingAddressState());
//     dispatch(actions.resetFamilyMember());
//     // Fetch addresses on component mount
//   }, []);

//   // const handleSelectAddress = (event) => {
//   //   setSelectedAddress(event.target.value); // Update selected address
//   // };
//   // This filter adult and child and infant data come from api
//   const adults = familyMembers.filter((member) => member.age >= 12);
//   const children = familyMembers.filter(
//     (member) => member.age >= 2 && member.age < 12
//   );
//   const infants = familyMembers.filter((member) => member.age < 2);
//   const navigate = useNavigate();
//   const formValues = watch();
//   const formValuess = {
//     ...formValues,
//     billing_address: selectedAddress,
//     family_members: selectedMembers,
//     customer_id: customerId || 0,
//   };

//   const {
//     fields: adultFields,
//     append: appendAdult,
//     remove: removeAdult,
//   } = useFieldArray({
//     control,
//     name: 'adults',
//   });
//   const {
//     fields: childFields,
//     append: appendChild,
//     remove: removeChild,
//   } = useFieldArray({
//     control,
//     name: 'children',
//   });
//   const {
//     fields: infantFields,
//     append: appendInfant,
//     remove: removeInfant,
//   } = useFieldArray({
//     control,
//     name: 'infants',
//   });
//   useEffect(() => {
//     const infantCount = parseInt(formValues.no_of_infant || 0, 10);
//     if (infantCount !== infantFields.length) {
//       if (infantCount > infantFields.length) {
//         for (let i = infantFields.length; i < infantCount; i++) {
//           appendInfant({
//             first_name: '',
//             last_name: '',
//             age: '',
//             country_code: ' ',
//             phone: '',
//             gender_type: '',
//             nationality: '',
//             havePassport: false,
//             passport_number: '',
//             aadhar_number: '',
//             type: '1',
//           });
//         }
//       } else {
//         // Remove extra fields
//         for (let i = infantFields.length - 1; i >= infantCount; i--) {
//           removeInfant(i);
//         }
//       }
//     }
//     // Handle Child Fields
//     const childCount = parseInt(formValues.no_of_child || 0, 10);
//     if (childCount !== childFields.length) {
//       if (childCount > childFields.length) {
//         for (let i = childFields.length; i < childCount; i++) {
//           appendChild({
//             first_name: '',
//             last_name: '',
//             age: '',
//             country_code: ' ',
//             phone: '',
//             nationality: '',
//             gender_type: '',
//             havePassport: false, // Passport switch field
//             passport_number: '', // Passport number field
//             aadhar_number: '',
//             type: '2',
//           });
//         }
//       } else {
//         for (let i = childFields.length - 1; i >= childCount; i--) {
//           removeChild(i);
//         }
//       }
//     }
//     // Handle Adult Fields
//     const adultCount = parseInt(formValues.no_of_adult || 0, 10);
//     if (adultCount !== adultFields.length) {
//       if (adultCount > adultFields.length) {
//         for (let i = adultFields.length; i < adultCount; i++) {
//           appendAdult({
//             first_name: '',
//             last_name: '',
//             age: '',
//             country_code: ' ',
//             phone: '',
//             nationality: '',
//             gender_type: '',
//             havePassport: false, // Passport switch field
//             passport_number: '', // Passport number field
//             aadhar_number: '',
//             type: '3',
//           });
//         }
//       } else {
//         for (let i = adultFields.length - 1; i >= adultCount; i--) {
//           removeAdult(i);
//         }
//       }
//     }
//   }, [
//     formValues.no_of_infant,
//     formValues.no_of_child,
//     formValues.no_of_adult,
//     infantFields.length,
//     childFields.length,
//     adultFields.length,
//     appendInfant,
//     removeInfant,
//     appendChild,
//     removeChild,
//     appendAdult,
//     removeAdult,
//   ]);

//   const nonNegativeValidation = {
//     min: {
//       value: 0,
//       message: 'Value cannot be negative',
//     },
//   };

//   const formFields = [
//     {
//       name: 'no_of_adult',
//       label: 'No of Adults',
//       placeholder: 'Adults Count',
//       type: 'text',
//       disabled: true,
//       rules: {
//         required: false,
//         ...nonNegativeValidation,
//       },
//       xs: 12,
//       md: 6,
//       lg: 3,
//     },
//     {
//       name: 'no_of_child',
//       label: 'No of Child',
//       placeholder: 'Children Count',
//       type: 'text',
//       disabled: true,
//       rules: {
//         required: false,
//         ...nonNegativeValidation,
//       },
//       xs: 12,
//       md: 6,
//       lg: 3,
//     },
//     {
//       name: 'no_of_infant',
//       label: 'No of Infant',
//       placeholder: 'Infants Count',
//       type: 'text',
//       disabled: true,
//       rules: {
//         required: false,
//         ...nonNegativeValidation,
//       },
//       xs: 12,
//       md: 6,
//       lg: 3,
//     },
//     {
//       name: 'total_passengers',
//       label: 'Total Passengers *',

//       type: 'number',
//       disabled: true,
//       rules: {
//         required: true,
//         ...nonNegativeValidation,
//         validate: (value) =>
//           value > 0 || 'please  add members to continue booking',
//       },
//       xs: 12,
//       md: 6,
//       lg: 3,
//     },
//     {
//       name: 'notes',
//       label: 'Notes',
//       placeholder: 'Enter any notes',
//       type: 'text',
//       rules: { required: false },
//       xs: 12,
//       md: 6,
//     },
//     {
//       name: 'total_services',
//       label: 'No of Service *',

//       disabled: true,
//       placeholder: 'please  add members to continue booking',
//       type: 'number',
//       rules: {
//         required: 'Required Service is Needed',
//         ...nonNegativeValidation,
//       },
//       xs: 12,
//       md: 6,
//     },
//   ];

//   useEffect(() => {
//     // Whenever the state values (noOfAdult, noOfChild, noOfInfant) change, update totalPassengers
//     setValue('no_of_adult', adultFamilyMember?.length);
//     setValue('no_of_child', childFamilyMember?.length);
//     setValue('no_of_infant', infantFamilyMember?.length);
//     const totalPassengers =
//       (parseInt(formValues.no_of_adult) || 0) +
//       (parseInt(formValues.no_of_child) || 0) +
//       (parseInt(formValues.no_of_infant) || 0);

//     setValue('total_passengers', totalPassengers); // Set the total passengers field value in React Hook Form

//     const totalServices =
//       (parseInt(formValues.no_of_adult) || 0) +
//       (parseInt(formValues.no_of_child) || 0);

//     setValue('total_services', totalServices);
//     if (totalPassengers > 0) {
//       clearErrors('total_passengers'); // Clear the error for totalPassengers if the value is valid
//     }
//   }, [
//     selectedMembers,
//     formValues.no_of_adult,
//     formValues.no_of_child,
//     formValues.no_of_infant,
//     setValue,
//   ]);
//   const isInternational = form1Value?.service_type?.value === 'International';

//   return (
//     <>
//       <ToastContainer />
//       <Box sx={{ marginBottom: '50px' }}>
//         <form
//           onSubmit={handleSubmit((data) => {
//             if (!selectedAddress) {
//               setAddressError(true);
//               return;
//             }

//             dispatch(resetBookingDetails());

//             navigate(INSTANT_BOOKING_SUMMARY, {
//               state: {
//                 form1Value: form1Value,
//                 form2Value: formValuess,
//                 form3Value: form3Value,
//               },
//             });
//           })}
//         >
//           <Grid container spacing={1}>
//             <Grid item xs={12} xl={8}>
//               <Box className='add-booking-passenger-details' component={Paper}>
//                 <Typography variant='h5' className='form-heading'>
//                   Add Booking (Select Passenger From Right)
//                 </Typography>
//                 <Box className='add-booking-form'>
//                   <Grid container xs={12} spacing={3}>
//                     {formFields.map((field, index) => (
//                       <Grid
//                         item
//                         xs={12}
//                         md={field.md}
//                         lg={field.lg}
//                         key={index}
//                       >
//                         <ControlledTextInputField
//                           name={field.name}
//                           control={control}
//                           rules={field.rules}
//                           type={field.type}
//                           disabled={field.disabled}
//                           label={field.label}
//                           radioOptions={field.radioOptions}
//                           placeholder={field.placeholder}
//                           options={field.options}
//                           getOptionLabel={(option) => option.label}
//                           error={!!errors[field.name]}
//                           helperText={errors[field.name]?.message}
//                         />
//                       </Grid>
//                     ))}
//                     <Grid item xs={12}>
//                       <Typography variant='h5' className='form-heading'>
//                         Customer Billing Address Details
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={12}>
//                       <Box
//                         sx={{
//                           maxHeight: '400px',
//                           overflowY: 'auto',
//                           padding: '10px',
//                           border: '1px solid #ccc',
//                           borderRadius: '8px',
//                           backgroundColor: '#F9F9F9',
//                         }}
//                       >
//                         {viewListLoading ? (
//                           <Typography>Loading addresses...</Typography>
//                         ) : addresses.length > 0 ? (
//                           <FormControl
//                             component='fieldset'
//                             error={addressError}
//                           >
//                             <RadioGroup
//                               value={selectedAddress}
//                               onChange={handleSelectAddress}
//                             >
//                               {addresses.map((address, index) => (
//                                 <Box
//                                   key={address.id}
//                                   sx={{
//                                     padding: '15px',
//                                     marginBottom: '10px',
//                                     backgroundColor: '#fff',
//                                     borderRadius: '8px',
//                                     boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
//                                   }}
//                                 >
//                                   <FormControlLabel
//                                     value={address.id.toString()}
//                                     control={<Radio />}
//                                     label={
//                                       <Box>
//                                         <Typography
//                                           variant='body1'
//                                           fontWeight='bold'
//                                         >
//                                           {address.address1}
//                                         </Typography>
//                                         <Typography variant='body2'>
//                                           {address.address2}
//                                         </Typography>
//                                         <Typography variant='body2'>
//                                           {address.country_name},{' '}
//                                           {address.state_name},{' '}
//                                           {address.city_name}, {address.pincode}
//                                         </Typography>
//                                       </Box>
//                                     }
//                                   />
//                                 </Box>
//                               ))}
//                             </RadioGroup>

//                             {addressError && (
//                               <Typography
//                                 variant='caption'
//                                 color='error'
//                                 sx={{ pl: 2 }}
//                               >
//                                 * Please select an address to proceed
//                               </Typography>
//                             )}
//                           </FormControl>
//                         ) : (
//                           <Typography>
//                             No saved addresses found. Add a new address below.
//                           </Typography>
//                         )}
//                       </Box>
//                     </Grid>

//                     <Grid item xs={12}>
//                       <Button
//                         variant='contained'
//                         onClick={handleOpen}
//                         className='add-address-button'
//                         sx={{ backgroundColor: '#FF5733', color: '#fff' }}
//                       >
//                         Add Address
//                       </Button>
//                       <Modal
//                         open={open}
//                         onClose={handleClose}
//                         aria-labelledby='modal-modal-title'
//                         aria-describedby='modal-modal-description'
//                       >
//                         <Box
//                           className='booking-modal'
//                           onClick={(e) => e.stopPropagation()}
//                         >
//                           <BookingAddAddressForm
//                             customerId={form1Value?.customerDetails?.id}
//                             handleClose={handleClose}
//                           />
//                         </Box>
//                       </Modal>
//                     </Grid>
//                   </Grid>
//                 </Box>
//               </Box>
//             </Grid>
//             <Grid item xs={12} xl={4}>
//               <Box className='add-booking-passenger-details' component={Paper}>
//                 <Grid item xs={12}>
//                   <Typography
//                     variant='h6'
//                     className='form-heading-family-members'
//                   >
//                     Passenger Details
//                   </Typography>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Box
//                     sx={{
//                       maxHeight: '875px',
//                       overflowY: 'auto',
//                       padding: '10px',
//                       border: '1px solid #ccc',
//                       borderRadius: '8px',
//                       backgroundColor: '#F9F9F9',
//                     }}
//                   >
//                     {familyMembers.length === 0 ? (
//                       <Box textAlign='center' mt={4}>
//                         <Typography variant='h6'>
//                           No family members found.
//                         </Typography>
//                       </Box>
//                     ) : (
//                       <>
//                         {/* Adults Section */}
//                         {adults.length > 0 && (
//                           <>
//                             <Typography
//                               variant='h6'
//                               sx={{ marginBottom: 2, fontWeight: 'bold' }}
//                             >
//                               Adults (12+ years)
//                               <Divider className='booking-summary-divider' />
//                             </Typography>
//                             <Grid container spacing={3}>
//                               {adults.map((member) => (
//                                 <Grid item xs={12} key={member.id}>
//                                   <Card
//                                     className='address-card'
//                                     sx={{
//                                       opacity:
//                                         form1Value?.service_type?.value ===
//                                           'International' &&
//                                         !member.passport_number
//                                           ? 0.6
//                                           : 1,
//                                       pointerEvents:
//                                         form1Value?.service_type?.value ===
//                                           'International' &&
//                                         !member.passport_number
//                                           ? 'none'
//                                           : 'auto',
//                                     }}
//                                   >
//                                     <CardContent>
//                                       <FormControlLabel
//                                         control={
//                                           <Checkbox
//                                             checked={selectedMembers?.some(
//                                               (m) => m.id === member.id
//                                             )}
//                                             onChange={() =>
//                                               handleCheckboxChange(member)
//                                             }
//                                             disabled={
//                                               form1Value?.service_type
//                                                 ?.value === 'International' &&
//                                               !member.passport_number
//                                             }
//                                           />
//                                         }
//                                         label={
//                                           <Typography
//                                             variant='h6'
//                                             className='address-name'
//                                           >
//                                             {member.first_name}{' '}
//                                             {member.last_name}
//                                           </Typography>
//                                         }
//                                       />
//                                       <Typography
//                                         variant='body1'
//                                         className='address-details'
//                                       >
//                                         Date of Birth: {formatDate(member.dob)}
//                                       </Typography>
//                                       <Typography
//                                         variant='body1'
//                                         className='mobile-info'
//                                       >
//                                         Gender:{' '}
//                                         {member.gender_type === 'M'
//                                           ? 'Male'
//                                           : member.gender_type === 'F'
//                                           ? 'Female'
//                                           : 'Others'}
//                                       </Typography>
//                                       <Typography
//                                         variant='body1'
//                                         className='address-details'
//                                       >
//                                         Age: {member.age}
//                                       </Typography>
//                                       <Typography
//                                         variant='body1'
//                                         className='address-details'
//                                       >
//                                         Nationality: {member.nationality}
//                                       </Typography>
//                                       {member.passport_number && (
//                                         <Typography
//                                           variant='body1'
//                                           className='address-details'
//                                         >
//                                           Passport Number:{' '}
//                                           {member.passport_number}
//                                         </Typography>
//                                       )}
//                                       {member.aadhar_number && (
//                                         <Typography
//                                           variant='body1'
//                                           className='address-details'
//                                         >
//                                           Aadhar Number: {member.aadhar_number}
//                                         </Typography>
//                                       )}
//                                       <Typography
//                                         variant='body2'
//                                         className='mobile-info'
//                                       >
//                                         Mobile: {member.phone || 'Not provided'}
//                                       </Typography>
//                                       {form1Value?.service_type?.value ===
//                                         'International' &&
//                                         !member.passport_number && (
//                                           <div
//                                             style={{
//                                               color: 'red',
//                                               fontSize: '0.875rem',
//                                               fontWeight: '500',
//                                             }}
//                                           >
//                                             <strong>Note:</strong> Passport
//                                             Number is mandatory for
//                                             International Service
//                                           </div>
//                                         )}
//                                     </CardContent>
//                                   </Card>
//                                 </Grid>
//                               ))}
//                             </Grid>
//                           </>
//                         )}

//                         {/* Children Section */}
//                         {children.length > 0 && (
//                           <>
//                             <Typography
//                               variant='h6'
//                               sx={{
//                                 marginTop: 3,
//                                 marginBottom: 2,
//                                 fontWeight: 'bold',
//                               }}
//                             >
//                               Children (2-12 years)
//                               <Divider className='booking-summary-divider' />
//                             </Typography>
//                             <Grid container spacing={3}>
//                               {children.map((member) => (
//                                 <Grid item xs={12} key={member.id}>
//                                   <Card
//                                     className='address-card'
//                                     sx={{
//                                       opacity:
//                                         form1Value?.service_type?.value ===
//                                           'International' &&
//                                         !member.passport_number
//                                           ? 0.6
//                                           : 1,
//                                       pointerEvents:
//                                         form1Value?.service_type?.value ===
//                                           'International' &&
//                                         !member.passport_number
//                                           ? 'none'
//                                           : 'auto',
//                                     }}
//                                   >
//                                     <CardContent>
//                                       <FormControlLabel
//                                         control={
//                                           <Checkbox
//                                             checked={selectedMembers?.some(
//                                               (m) => m.id === member.id
//                                             )}
//                                             onChange={() =>
//                                               handleCheckboxChange(member)
//                                             }
//                                             disabled={
//                                               form1Value?.service_type
//                                                 ?.value === 'International' &&
//                                               !member.passport_number
//                                             }
//                                           />
//                                         }
//                                         label={
//                                           <Typography
//                                             variant='h6'
//                                             className='address-name'
//                                           >
//                                             {member.first_name}{' '}
//                                             {member.last_name}
//                                           </Typography>
//                                         }
//                                       />
//                                       <Typography
//                                         variant='body1'
//                                         className='address-details'
//                                       >
//                                         Date of Birth: {formatDate(member.dob)}
//                                       </Typography>
//                                       <Typography
//                                         variant='body1'
//                                         className='mobile-info'
//                                       >
//                                         Gender:{' '}
//                                         {member.gender_type === 'M'
//                                           ? 'Male'
//                                           : member.gender_type === 'F'
//                                           ? 'Female'
//                                           : 'Others'}
//                                       </Typography>
//                                       <Typography
//                                         variant='body1'
//                                         className='address-details'
//                                       >
//                                         Age: {member.age}
//                                       </Typography>
//                                       <Typography
//                                         variant='body1'
//                                         className='address-details'
//                                       >
//                                         Nationality: {member.nationality}
//                                       </Typography>
//                                       {member.passport_number && (
//                                         <Typography
//                                           variant='body1'
//                                           className='address-details'
//                                         >
//                                           Passport Number:{' '}
//                                           {member.passport_number}
//                                         </Typography>
//                                       )}
//                                       {member.aadhar_number && (
//                                         <Typography
//                                           variant='body1'
//                                           className='address-details'
//                                         >
//                                           Aadhar Number: {member.aadhar_number}
//                                         </Typography>
//                                       )}
//                                       <Typography
//                                         variant='body2'
//                                         className='mobile-info'
//                                       >
//                                         Mobile: {member.phone || 'Not provided'}
//                                       </Typography>

//                                       {form1Value?.service_type?.value ===
//                                         'International' &&
//                                         !member.passport_number && (
//                                           <div
//                                             style={{
//                                               color: 'red',
//                                               fontSize: '0.875rem',
//                                               fontWeight: '500',
//                                             }}
//                                           >
//                                             <strong>Note:</strong> Passport
//                                             Number is mandatory for
//                                             International Service
//                                           </div>
//                                         )}
//                                     </CardContent>
//                                   </Card>
//                                 </Grid>
//                               ))}
//                             </Grid>
//                           </>
//                         )}

//                         {/* Infants Section */}
//                         {infants.length > 0 && (
//                           <>
//                             <Typography
//                               variant='h6'
//                               sx={{
//                                 marginTop: 3,
//                                 marginBottom: 2,
//                                 fontWeight: 'bold',
//                               }}
//                             >
//                               Infants (0-2 years)
//                               <Divider className='booking-summary-divider' />
//                             </Typography>
//                             <Grid container spacing={3}>
//                               {infants.map((member) => (
//                                 <Grid item xs={12} key={member.id}>
//                                   <Card
//                                     className='address-card'
//                                     sx={{
//                                       opacity:
//                                         form1Value?.service_type?.value ===
//                                           'International' &&
//                                         !member.passport_number
//                                           ? 0.6
//                                           : 1,
//                                       pointerEvents:
//                                         form1Value?.service_type?.value ===
//                                           'International' &&
//                                         !member.passport_number
//                                           ? 'none'
//                                           : 'auto',
//                                     }}
//                                   >
//                                     <CardContent>
//                                       <FormControlLabel
//                                         control={
//                                           <Checkbox
//                                             checked={selectedMembers?.some(
//                                               (m) => m.id === member.id
//                                             )}
//                                             onChange={() =>
//                                               handleCheckboxChange(member)
//                                             }
//                                             disabled={
//                                               form1Value?.service_type
//                                                 ?.value === 'International' &&
//                                               !member.passport_number
//                                             }
//                                           />
//                                         }
//                                         label={
//                                           <Typography
//                                             variant='h6'
//                                             className='address-name'
//                                           >
//                                             {member.first_name}{' '}
//                                             {member.last_name}
//                                           </Typography>
//                                         }
//                                       />
//                                       <Typography
//                                         variant='body1'
//                                         className='address-details'
//                                       >
//                                         Date of Birth: {formatDate(member.dob)}
//                                       </Typography>
//                                       <Typography
//                                         variant='body1'
//                                         className='mobile-info'
//                                       >
//                                         Gender:{' '}
//                                         {member.gender_type === 'M'
//                                           ? 'Male'
//                                           : member.gender_type === 'F'
//                                           ? 'Female'
//                                           : 'Others'}
//                                       </Typography>
//                                       <Typography
//                                         variant='body1'
//                                         className='address-details'
//                                       >
//                                         Age: {member.age}
//                                       </Typography>
//                                       <Typography
//                                         variant='body1'
//                                         className='address-details'
//                                       >
//                                         Nationality: {member.nationality}
//                                       </Typography>
//                                       {member.passport_number && (
//                                         <Typography
//                                           variant='body1'
//                                           className='address-details'
//                                         >
//                                           Passport Number:{' '}
//                                           {member.passport_number}
//                                         </Typography>
//                                       )}
//                                       {member.aadhar_number && (
//                                         <Typography
//                                           variant='body1'
//                                           className='address-details'
//                                         >
//                                           Aadhar Number: {member.aadhar_number}
//                                         </Typography>
//                                       )}
//                                       <Typography
//                                         variant='body2'
//                                         className='mobile-info'
//                                       >
//                                         Mobile: {member.phone || 'Not provided'}
//                                       </Typography>

//                                       {form1Value?.service_type?.value ===
//                                         'International' &&
//                                         !member.passport_number && (
//                                           <div
//                                             style={{
//                                               color: 'red',
//                                               fontSize: '0.875rem',
//                                               fontWeight: '500',
//                                             }}
//                                           >
//                                             <strong>Note:</strong> Passport
//                                             Number is mandatory for
//                                             International Service
//                                           </div>
//                                         )}
//                                     </CardContent>
//                                   </Card>
//                                   {/* dfsd */}
//                                 </Grid>
//                               ))}
//                             </Grid>
//                           </>
//                         )}
//                       </>
//                     )}
//                   </Box>
//                 </Grid>

//                 <Grid item xs={12} sx={{ marginTop: '15px' }}>
//                   <Typography className='typography-message'>
//                     <StarSymbol>*</StarSymbol> For special requests or
//                     unavailable dates, call our customer care @ +91-7 44 888 77
//                     11.
//                   </Typography>
//                 </Grid>

//                 <Grid item xs={12}>
//                   <Typography className='typography-message'>
//                     <StarSymbol>*</StarSymbol> Each service covers assistance
//                     for one guest and up to three bags, regardless of the total
//                     number of passengers or bags. Infants aged 0-2 years are
//                     complimentary, while children aged 2-12 years receive a 30%
//                     discount on the adult rate.
//                   </Typography>
//                 </Grid>

//                 <Grid item xs={12}>
//                   <Typography className='typography-message'>
//                     <StarSymbol>*</StarSymbol> For additional services related
//                     to children, please ensure you book the necessary number of
//                     services.
//                   </Typography>
//                 </Grid>

//                 <Grid item xs={12} sx={{ marginTop: '20px' }}>
//                   <Button
//                     variant='contained'
//                     onClick={addFamilyMemberModalOpen}
//                     className='add-address-button'
//                     sx={{ backgroundColor: '#FF5733', color: '#fff' }}
//                   >
//                     Add Passenger Detail
//                   </Button>
//                   <Modal
//                     open={familyMemberOpen}
//                     onClose={addFamilyMemberModalClose}
//                     aria-labelledby='modal-modal-title'
//                     aria-describedby='modal-modal-description'
//                   >
//                     <Box
//                       className='booking-modal'
//                       onClick={(e) => e.stopPropagation()}
//                     >
//                       <BookingAddFamilyMember
//                         customerNo={
//                           customerId ||
//                           form1Value?.customerDetails?.id ||
//                           user.customer_id
//                         }
//                         addFamilyMemberModalClose={addFamilyMemberModalClose}
//                         isInternational={isInternational}
//                       />
//                     </Box>
//                   </Modal>
//                 </Grid>
//               </Box>
//             </Grid>
//             {/* Navigation Buttons */}
//             <Grid item xs={12}>
//               <Box className='button-passenger-container'>
//                 <CustomButton
//                   variant='contained'
//                   className='cancel-button'
//                   type='button'
//                   text={'back'}
//                   state1={form1Value}
//                   state2={formValuess}
//                   state3={form3Value}
//                   link={INSTANT_BOOKING_AIRPORT_DETAILS}
//                 />

//                 <CustomButton
//                   variant='contained'
//                   className='success-button'
//                   type='Submit'
//                   onClick={() => {
//                     dispatch(resetBookingDetails());
//                   }}
//                   text={'Submit'}
//                 />
//               </Box>
//             </Grid>
//           </Grid>
//         </form>
//       </Box>
//     </>
//   );
// };
// export default Form2;


import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import Modal from '@mui/material/Modal';
import React, { useEffect, useState } from 'react';
import { formatDate, StarSymbol } from '../../Style';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  INSTANT_BOOKING_AIRPORT_DETAILS,
  INSTANT_BOOKING_SUMMARY,
} from '../../component/common/Routes/AppRoutes';
import 'react-perfect-scrollbar/dist/css/styles.css';
import CustomButton from '../../component/ui/FormFields/Button';
import ControlledTextInputField from '../../component/ui/FormFields/ControlledTextInputField';
import { selectCountryRequest } from '../../redux/Common/selectorAction';
import { useDispatch, useSelector } from 'react-redux';

import {
  fetchBillingAddressesRequest,
  resetBillingAddressState,
} from '../../redux/BillingAddress/BillingAddressAction';
import { resetBookingDetails } from '../../redux/Bookings/BookingAction';
import { toast, ToastContainer } from 'react-toastify';
import BookingAddAddressForm from '../Address/BookingBillingAddress';
import * as actions from '../../redux/FamilyMembers/actions';
import BookingAddFamilyMember from '../FamilyMembers/BookingAddFamilyMember';
const Form2 = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const form1Value = location.state?.form1Value || {};
  const hasPorterService = [
    form1Value?.departure_plan,
    form1Value?.arrival_plan,
    form1Value?.transit_plan,
  ].some((plan) => plan?.label?.toLowerCase()?.includes('porter'));

  const form2Value = location.state?.form2Value || {};
  const form3Value = location.state?.form3Value || {};
  const [open, setOpen] = React.useState(false);
  const user = useSelector((state) => state.auth.user);
  const [addressError, setAddressError] = useState(false);
  const customerId = form1Value?.customer?.value;
  const [familyMemberOpen, setFamilyMemberOpen] = React.useState(false);
  const addFamilyMemberModalOpen = () => setFamilyMemberOpen(true);
  const addFamilyMemberModalClose = () => {
    setFamilyMemberOpen(false);
    dispatch(
      actions.fetchFamilyMembersRequest(
        user?.customer_id || customerId || form1Value?.customerDetails?.id
      )
    );
  };
  const handleSelectAddress = (event) => {
    setSelectedAddress(event.target.value);
    setAddressError(false); // Clear error when user selects
  };
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    dispatch(
      fetchBillingAddressesRequest(
        user?.customer_id || customerId || form1Value?.customerDetails?.id
      )
    );
  };
  const servicePlan=[form1Value?.arrival_plan?.label,form1Value?.departure_plan?.label,form1Value?.transit_plan?.label];
   const isPorterService=servicePlan?.some((service)=> service?.toLowerCase().includes("porter"));
     const serviceType=[form1Value?.service_type?.value,form1Value?.transit_service?.label];
 const  isInternationalService=serviceType?.some((service)=>service?.toLowerCase().includes("international"));
   

  const [selectedAddress, setSelectedAddress] = useState('');
  const [selectedMembers, setSelectedMembers] = useState([]);
  const adultFamilyMember = selectedMembers?.filter((adult) => {
    return adult?.age >= 12;
  });
  const infantFamilyMember = selectedMembers?.filter((infant) => {
    return infant?.age < 2;
  });
  const childFamilyMember = selectedMembers?.filter((child) => {
    return child?.age >= 2 && child?.age < 12;
  });
  const { familyMembers, loading, error } = useSelector(
    (state) => state.familyMember
  );
  useEffect(() => {
    setSelectedAddress(form2Value?.billing_address);
    setSelectedMembers(form2Value?.family_members);
  }, [form2Value?.billing_address]);
  const {
    formState: { errors },
    control,
    handleSubmit,
    watch,
    setValue,
    clearErrors,
  } = useForm({
    defaultValues: {
      no_of_adult: form2Value.no_of_adult || '',
      no_of_child: form2Value.no_of_child || '',
      no_of_infant: form2Value.no_of_infant || '',
      total_services: form2Value.total_services || '1',
      total_passengers: form2Value.total_passengers || '',

      city: form2Value?.city
        ? {
            label: form2Value?.city?.label.replace('_', ' ').toUpperCase(),
            value: form2Value?.city?.label,
          }
        : null,
      state: form2Value?.state
        ? {
            label: form2Value?.state?.label.replace('_', ' ').toUpperCase(),
            value: form2Value?.state?.label,
          }
        : null,
      country: form2Value?.country
        ? {
            label: form2Value?.country?.label.replace('_', ' ').toUpperCase(),
            value: form2Value?.country?.label,
          }
        : null,

      notes: form2Value?.notes || '',
      company_name: form2Value?.company_name || '',
      gstin_number: form2Value?.gstin_number || '',
      pincode: form2Value?.pincode || '',
      address: form2Value?.address || '',
      adults: form2Value?.adults || [
        {
          first_name: '',
          last_name: '',
          age: '',
          phone: '',
          gender_type: '',
          country_code: ' ',
          havePassport: false, // Passport switch field
          passport_number: '', // Passport number field
          aadhar_number: '',
          nationality: '',
          type: '3',
        },
      ],
      children: form2Value.children || [
        {
          first_name: '',
          last_name: '',
          age: '',
          country_code: ' ',
          phone: '',
          gender_type: '',
          nationality: '',
          havePassport: false, // Passport switch field
          passport_number: '', // Passport number field
          aadhar_number: '',
          type: '2',
        },
      ], // Default fields for children
      infants: form2Value.infants || [
        {
          first_name: '',
          last_name: '',
          age: '',
          country_code: ' ',
          phone: '',
          type: '1',
          gender_type: '',
          nationality: '',
          havePassport: false, // Passport switch field
          passport_number: '', // Passport number field
          aadhar_number: '',
          type: '1',
        },
      ], // Default fields for infants
    },
  });

  // address selector

  useEffect(() => {
    dispatch(selectCountryRequest());
  }, []);

  const formValue = watch();

  const {
    addresses = [],
    loading: viewListLoading,
    address: successMessage,
  } = useSelector((state) => state.billingAddress);
  const handleCheckboxChange = (member) => {
    setSelectedMembers((prevSelected = []) => {
      const isAlreadySelected = prevSelected.some((m) => m.id === member.id);

      if (isAlreadySelected) {
        return prevSelected.filter((m) => m.id !== member.id);
      } else {
        return [...prevSelected, member];
      }
    });
  };
  useEffect(() => {
    if (isInternationalService) {
      setSelectedMembers((prevSelected) =>
        prevSelected?.filter((m) => !!m.passport_number) // keep only members with passport
      );
    }
  }, [isInternationalService]);
  useEffect(() => {
    dispatch(
      fetchBillingAddressesRequest(
        user.customer_id || customerId || form1Value?.customerDetails?.id
      )
    );
    dispatch(
      actions.fetchFamilyMembersRequest(
        user.customer_id || customerId || form1Value?.customerDetails?.id
      )
    );

    dispatch(resetBillingAddressState());
    dispatch(actions.resetFamilyMember());
    // Fetch addresses on component mount
  }, []);

  // const handleSelectAddress = (event) => {
  //   setSelectedAddress(event.target.value); // Update selected address
  // };
  // This filter adult and child and infant data come from api
  const adults = familyMembers.filter((member) => member.age >= 12);
  const children = familyMembers.filter(
    (member) => member.age >= 2 && member.age < 12
  );
  const infants = familyMembers.filter((member) => member.age < 2);
  const navigate = useNavigate();
  const formValues = watch();
  const formValuess = {
    ...formValues,
    billing_address: selectedAddress,
    family_members: selectedMembers,
    customer_id: customerId || 0,
  };

  const {
    fields: adultFields,
    append: appendAdult,
    remove: removeAdult,
  } = useFieldArray({
    control,
    name: 'adults',
  });
  const {
    fields: childFields,
    append: appendChild,
    remove: removeChild,
  } = useFieldArray({
    control,
    name: 'children',
  });
  const {
    fields: infantFields,
    append: appendInfant,
    remove: removeInfant,
  } = useFieldArray({
    control,
    name: 'infants',
  });
  useEffect(() => {
    const infantCount = parseInt(formValues.no_of_infant || 0, 10);
    if (infantCount !== infantFields.length) {
      if (infantCount > infantFields.length) {
        for (let i = infantFields.length; i < infantCount; i++) {
          appendInfant({
            first_name: '',
            last_name: '',
            age: '',
            country_code: ' ',
            phone: '',
            gender_type: '',
            nationality: '',
            havePassport: false,
            passport_number: '',
            aadhar_number: '',
            type: '1',
          });
        }
      } else {
        // Remove extra fields
        for (let i = infantFields.length - 1; i >= infantCount; i--) {
          removeInfant(i);
        }
      }
    }
    // Handle Child Fields
    const childCount = parseInt(formValues.no_of_child || 0, 10);
    if (childCount !== childFields.length) {
      if (childCount > childFields.length) {
        for (let i = childFields.length; i < childCount; i++) {
          appendChild({
            first_name: '',
            last_name: '',
            age: '',
            country_code: ' ',
            phone: '',
            nationality: '',
            gender_type: '',
            havePassport: false, // Passport switch field
            passport_number: '', // Passport number field
            aadhar_number: '',
            type: '2',
          });
        }
      } else {
        for (let i = childFields.length - 1; i >= childCount; i--) {
          removeChild(i);
        }
      }
    }
    // Handle Adult Fields
    const adultCount = parseInt(formValues.no_of_adult || 0, 10);
    if (adultCount !== adultFields.length) {
      if (adultCount > adultFields.length) {
        for (let i = adultFields.length; i < adultCount; i++) {
          appendAdult({
            first_name: '',
            last_name: '',
            age: '',
            country_code: ' ',
            phone: '',
            nationality: '',
            gender_type: '',
            havePassport: false, // Passport switch field
            passport_number: '', // Passport number field
            aadhar_number: '',
            type: '3',
          });
        }
      } else {
        for (let i = adultFields.length - 1; i >= adultCount; i--) {
          removeAdult(i);
        }
      }
    }
  }, [
    formValues.no_of_infant,
    formValues.no_of_child,
    formValues.no_of_adult,
    infantFields.length,
    childFields.length,
    adultFields.length,
    appendInfant,
    removeInfant,
    appendChild,
    removeChild,
    appendAdult,
    removeAdult,
  ]);

  const nonNegativeValidation = {
    min: {
      value: 0,
      message: 'Value cannot be negative',
    },
  };

  const formFields = [
    {
      name: 'no_of_adult',
      label: 'No of Adults',
      placeholder: 'Adults Count',
      type: 'text',
      disabled: true,
      rules: {
        required: false,
        ...nonNegativeValidation,
      },
      xs: 12,
      md: 6,
      lg: 3,
    },
    {
      name: 'no_of_child',
      label: 'No of Child',
      placeholder: 'Children Count',
      type: 'text',
      disabled: true,
      rules: {
        required: false,
        ...nonNegativeValidation,
      },
      xs: 12,
      md: 6,
      lg: 3,
    },
    {
      name: 'no_of_infant',
      label: 'No of Infant',
      placeholder: 'Infants Count',
      type: 'text',
      disabled: true,
      rules: {
        required: false,
        ...nonNegativeValidation,
      },
      xs: 12,
      md: 6,
      lg: 3,
    },
    {
      name: 'total_passengers',
      label: 'Total Passengers *',

      type: 'number',
      disabled: true,
      rules: {
        required: true,
        ...nonNegativeValidation,
        validate: (value) =>
          value > 0 || 'please  add members to continue booking',
      },
      xs: 12,
      md: 6,
      lg: 3,
    },
    {
      name: 'notes',
      label: 'Notes',
      placeholder: 'Enter any notes',
      type: 'text',
      rules: { required: false },
      xs: 12,
      md: 6,
    },
    {
      name: 'total_services',
      label: 'No of Service *',

       disabled:isPorterService? false:true,
      placeholder: 'please  add members to continue booking',
      type: 'number',
      rules: {
        required: 'Required Service is Needed',
        ...nonNegativeValidation,
      },
      xs: 12,
      md: 6,
    },
  ];

  useEffect(() => {
    // Whenever the state values (noOfAdult, noOfChild, noOfInfant) change, update totalPassengers
    setValue('no_of_adult', adultFamilyMember?.length);
    setValue('no_of_child', childFamilyMember?.length);
    setValue('no_of_infant', infantFamilyMember?.length);
    const totalPassengers =
      (parseInt(formValues.no_of_adult) || 0) +
      (parseInt(formValues.no_of_child) || 0) +
      (parseInt(formValues.no_of_infant) || 0);

    setValue('total_passengers', totalPassengers); // Set the total passengers field value in React Hook Form

    const totalServices =
      (parseInt(formValues.no_of_adult) || 0) +
      (parseInt(formValues.no_of_child) || 0);

    !isPorterService && setValue('total_services',totalServices);
    if (totalPassengers > 0) {
      clearErrors('total_passengers'); // Clear the error for totalPassengers if the value is valid
    }
  }, [
    selectedMembers,
    formValues.no_of_adult,
    formValues.no_of_child,
    formValues.no_of_infant,
    setValue,
  ]);
  const isInternational = form1Value?.service_type?.value === 'International';

  return (
    <>
      <ToastContainer />
      <Box sx={{ marginBottom: '50px' }}>
        <form
          onSubmit={handleSubmit((data) => {
            if (!selectedAddress) {
              setAddressError(true);
              return;
            }

            dispatch(resetBookingDetails());

            navigate(INSTANT_BOOKING_SUMMARY, {
              state: {
                form1Value: form1Value,
                form2Value: formValuess,
                form3Value: form3Value,
              },
            });
          })}
        >
          <Grid container spacing={1}>
            <Grid item xs={12} xl={8}>
              <Box className='add-booking-passenger-details' component={Paper}>
                <Typography variant='h5' className='form-heading'>
                  Add Booking (Select Passenger From Right)
                </Typography>
                <Box className='add-booking-form'>
                  <Grid container xs={12} spacing={3}>
                    {formFields.map((field, index) => (
                      <Grid
                        item
                        xs={12}
                        md={field.md}
                        lg={field.lg}
                        key={index}
                      >
                        <ControlledTextInputField
                          name={field.name}
                          control={control}
                          rules={field.rules}
                          type={field.type}
                          disabled={field.disabled}
                          label={field.label}
                          radioOptions={field.radioOptions}
                          placeholder={field.placeholder}
                          options={field.options}
                          getOptionLabel={(option) => option.label}
                          error={!!errors[field.name]}
                          helperText={errors[field.name]?.message}
                        />
                      </Grid>
                    ))}
                    <Grid item xs={12}>
                      <Typography variant='h5' className='form-heading'>
                        Customer Billing Address Details
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          maxHeight: '400px',
                          overflowY: 'auto',
                          padding: '10px',
                          border: '1px solid #ccc',
                          borderRadius: '8px',
                          backgroundColor: '#F9F9F9',
                        }}
                      >
                        {viewListLoading ? (
                          <Typography>Loading addresses...</Typography>
                        ) : addresses.length > 0 ? (
                          <FormControl
                            component='fieldset'
                            error={addressError}
                          >
                            <RadioGroup
                              value={selectedAddress}
                              onChange={handleSelectAddress}
                            >
                              {addresses.map((address, index) => (
                                <Box
                                  key={address.id}
                                  sx={{
                                    padding: '15px',
                                    marginBottom: '10px',
                                    backgroundColor: '#fff',
                                    borderRadius: '8px',
                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                  }}
                                >
                                  <FormControlLabel
                                    value={address.id.toString()}
                                    control={<Radio />}
                                    label={
                                      <Box>
                                        <Typography
                                          variant='body1'
                                          fontWeight='bold'
                                        >
                                          {address.address1}
                                        </Typography>
                                        <Typography variant='body2'>
                                          {address.address2}
                                        </Typography>
                                        <Typography variant='body2'>
                                          {address.country_name},{' '}
                                          {address.state_name},{' '}
                                          {address.city_name}, {address.pincode}
                                        </Typography>
                                      </Box>
                                    }
                                  />
                                </Box>
                              ))}
                            </RadioGroup>

                            {addressError && (
                              <Typography
                                variant='caption'
                                color='error'
                                sx={{ pl: 2 }}
                              >
                                * Please select an address to proceed
                              </Typography>
                            )}
                          </FormControl>
                        ) : (
                          <Typography>
                            No saved addresses found. Add a new address below.
                          </Typography>
                        )}
                      </Box>
                    </Grid>

                    <Grid item xs={12}>
                      <Button
                        variant='contained'
                        onClick={handleOpen}
                        className='add-address-button'
                        sx={{ backgroundColor: '#FF5733', color: '#fff' }}
                      >
                        Add Address
                      </Button>
                      <Modal
                        open={open}
                        onClose={handleClose}
                        aria-labelledby='modal-modal-title'
                        aria-describedby='modal-modal-description'
                      >
                        <Box
                          className='booking-modal'
                          onClick={(e) => e.stopPropagation()}
                        >
                          <BookingAddAddressForm
                            customerId={form1Value?.customerDetails?.id}
                            handleClose={handleClose}
                          />
                        </Box>
                      </Modal>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} xl={4}>
              <Box className='add-booking-passenger-details' component={Paper}>
                <Grid item xs={12}>
                  <Typography
                    variant='h6'
                    className='form-heading-family-members'
                  >
                    Passenger Details
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      maxHeight: '875px',
                      overflowY: 'auto',
                      padding: '10px',
                      border: '1px solid #ccc',
                      borderRadius: '8px',
                      backgroundColor: '#F9F9F9',
                    }}
                  >
                    {familyMembers.length === 0 ? (
                      <Box textAlign='center' mt={4}>
                        <Typography variant='h6'>
                          No family members found.
                        </Typography>
                      </Box>
                    ) : (
                      <>
                        {/* Adults Section */}
                        {adults.length > 0 && (
                          <>
                            <Typography
                              variant='h6'
                              sx={{ marginBottom: 2, fontWeight: 'bold' }}
                            >
                              Adults (12+ years)
                              <Divider className='booking-summary-divider' />
                            </Typography>
                            <Grid container spacing={3}>
                              {adults.map((member) => (
                                <Grid item xs={12} key={member.id}>
                                  <Card
                                    className='address-card'
                                    sx={{
                                      opacity:
                                     isInternationalService &&
                                        !member.passport_number
                                          ? 0.6
                                          : 1,
                                      pointerEvents:
                                        isInternationalService &&
                                        !member.passport_number
                                          ? 'none'
                                          : 'auto',
                                    }}
                                  >
                                    <CardContent>
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            checked={selectedMembers?.some(
                                              (m) => m.id === member.id
                                            )}
                                            onChange={() =>
                                              handleCheckboxChange(member)
                                            }
                                            disabled={
                                             isInternationalService &&
                                              !member.passport_number
                                            }
                                          />
                                        }
                                        label={
                                          <Typography
                                            variant='h6'
                                            className='address-name'
                                          >
                                            {member.first_name}{' '}
                                            {member.last_name}
                                          </Typography>
                                        }
                                      />
                                      <Typography
                                        variant='body1'
                                        className='address-details'
                                      >
                                        Date of Birth: {formatDate(member.dob)}
                                      </Typography>
                                      <Typography
                                        variant='body1'
                                        className='mobile-info'
                                      >
                                        Gender:{' '}
                                        {member.gender_type === 'M'
                                          ? 'Male'
                                          : member.gender_type === 'F'
                                          ? 'Female'
                                          : 'Others'}
                                      </Typography>
                                      <Typography
                                        variant='body1'
                                        className='address-details'
                                      >
                                        Age: {member.age}
                                      </Typography>
                                      <Typography
                                        variant='body1'
                                        className='address-details'
                                      >
                                        Nationality: {member.nationality}
                                      </Typography>
                                      {member.passport_number && (
                                        <Typography
                                          variant='body1'
                                          className='address-details'
                                        >
                                          Passport Number:{' '}
                                          {member.passport_number}
                                        </Typography>
                                      )}
                                      {member.aadhar_number && (
                                        <Typography
                                          variant='body1'
                                          className='address-details'
                                        >
                                          Aadhar Number: {member.aadhar_number}
                                        </Typography>
                                      )}
                                      <Typography
                                        variant='body2'
                                        className='mobile-info'
                                      >
                                        Mobile: {member.phone || 'Not provided'}
                                      </Typography>
                                      {isInternationalService &&
                                        !member.passport_number && (
                                          <div
                                            style={{
                                              color: 'red',
                                              fontSize: '0.875rem',
                                              fontWeight: '500',
                                            }}
                                          >
                                            <strong>Note:</strong> Passport
                                            Number is mandatory for
                                            International Service
                                          </div>
                                        )}
                                    </CardContent>
                                  </Card>
                                </Grid>
                              ))}
                            </Grid>
                          </>
                        )}

                        {/* Children Section */}
                        {children.length > 0 && (
                          <>
                            <Typography
                              variant='h6'
                              sx={{
                                marginTop: 3,
                                marginBottom: 2,
                                fontWeight: 'bold',
                              }}
                            >
                              Children (2-12 years)
                              <Divider className='booking-summary-divider' />
                            </Typography>
                            <Grid container spacing={3}>
                              {children.map((member) => (
                                <Grid item xs={12} key={member.id}>
                                  <Card
                                    className='address-card'
                                    sx={{
                                      opacity:
                                        isInternationalService &&
                                        !member.passport_number
                                          ? 0.6
                                          : 1,
                                      pointerEvents:
                                        isInternationalService &&
                                        !member.passport_number
                                          ? 'none'
                                          : 'auto',
                                    }}
                                  >
                                    <CardContent>
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            checked={selectedMembers?.some(
                                              (m) => m.id === member.id
                                            )}
                                            onChange={() =>
                                              handleCheckboxChange(member)
                                            }
                                            disabled={
                                             isInternationalService &&
                                              !member.passport_number
                                            }
                                          />
                                        }
                                        label={
                                          <Typography
                                            variant='h6'
                                            className='address-name'
                                          >
                                            {member.first_name}{' '}
                                            {member.last_name}
                                          </Typography>
                                        }
                                      />
                                      <Typography
                                        variant='body1'
                                        className='address-details'
                                      >
                                        Date of Birth: {formatDate(member.dob)}
                                      </Typography>
                                      <Typography
                                        variant='body1'
                                        className='mobile-info'
                                      >
                                        Gender:{' '}
                                        {member.gender_type === 'M'
                                          ? 'Male'
                                          : member.gender_type === 'F'
                                          ? 'Female'
                                          : 'Others'}
                                      </Typography>
                                      <Typography
                                        variant='body1'
                                        className='address-details'
                                      >
                                        Age: {member.age}
                                      </Typography>
                                      <Typography
                                        variant='body1'
                                        className='address-details'
                                      >
                                        Nationality: {member.nationality}
                                      </Typography>
                                      {member.passport_number && (
                                        <Typography
                                          variant='body1'
                                          className='address-details'
                                        >
                                          Passport Number:{' '}
                                          {member.passport_number}
                                        </Typography>
                                      )}
                                      {member.aadhar_number && (
                                        <Typography
                                          variant='body1'
                                          className='address-details'
                                        >
                                          Aadhar Number: {member.aadhar_number}
                                        </Typography>
                                      )}
                                      <Typography
                                        variant='body2'
                                        className='mobile-info'
                                      >
                                        Mobile: {member.phone || 'Not provided'}
                                      </Typography>

                                      {isInternationalService &&
                                        !member.passport_number && (
                                          <div
                                            style={{
                                              color: 'red',
                                              fontSize: '0.875rem',
                                              fontWeight: '500',
                                            }}
                                          >
                                            <strong>Note:</strong> Passport
                                            Number is mandatory for
                                            International Service
                                          </div>
                                        )}
                                    </CardContent>
                                  </Card>
                                </Grid>
                              ))}
                            </Grid>
                          </>
                        )}

                        {/* Infants Section */}
                        {infants.length > 0 && (
                          <>
                            <Typography
                              variant='h6'
                              sx={{
                                marginTop: 3,
                                marginBottom: 2,
                                fontWeight: 'bold',
                              }}
                            >
                              Infants (0-2 years)
                              <Divider className='booking-summary-divider' />
                            </Typography>
                            <Grid container spacing={3}>
                              {infants.map((member) => (
                                <Grid item xs={12} key={member.id}>
                                  <Card
                                    className='address-card'
                                    sx={{
                                      opacity:
                                    isInternationalService &&
                                        !member.passport_number
                                          ? 0.6
                                          : 1,
                                      pointerEvents:
                                      isInternationalService &&
                                        !member.passport_number
                                          ? 'none'
                                          : 'auto',
                                    }}
                                  >
                                    <CardContent>
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            checked={selectedMembers?.some(
                                              (m) => m.id === member.id
                                            )}
                                            onChange={() =>
                                              handleCheckboxChange(member)
                                            }
                                            disabled={
                                         isInternationalService &&
                                              !member.passport_number
                                            }
                                          />
                                        }
                                        label={
                                          <Typography
                                            variant='h6'
                                            className='address-name'
                                          >
                                            {member.first_name}{' '}
                                            {member.last_name}
                                          </Typography>
                                        }
                                      />
                                      <Typography
                                        variant='body1'
                                        className='address-details'
                                      >
                                        Date of Birth: {formatDate(member.dob)}
                                      </Typography>
                                      <Typography
                                        variant='body1'
                                        className='mobile-info'
                                      >
                                        Gender:{' '}
                                        {member.gender_type === 'M'
                                          ? 'Male'
                                          : member.gender_type === 'F'
                                          ? 'Female'
                                          : 'Others'}
                                      </Typography>
                                      <Typography
                                        variant='body1'
                                        className='address-details'
                                      >
                                        Age: {member.age}
                                      </Typography>
                                      <Typography
                                        variant='body1'
                                        className='address-details'
                                      >
                                        Nationality: {member.nationality}
                                      </Typography>
                                      {member.passport_number && (
                                        <Typography
                                          variant='body1'
                                          className='address-details'
                                        >
                                          Passport Number:{' '}
                                          {member.passport_number}
                                        </Typography>
                                      )}
                                      {member.aadhar_number && (
                                        <Typography
                                          variant='body1'
                                          className='address-details'
                                        >
                                          Aadhar Number: {member.aadhar_number}
                                        </Typography>
                                      )}
                                      <Typography
                                        variant='body2'
                                        className='mobile-info'
                                      >
                                        Mobile: {member.phone || 'Not provided'}
                                      </Typography>

                                      {isInternationalService&&
                                        !member.passport_number && (
                                          <div
                                            style={{
                                              color: 'red',
                                              fontSize: '0.875rem',
                                              fontWeight: '500',
                                            }}
                                          >
                                            <strong>Note:</strong> Passport
                                            Number is mandatory for
                                            International Service
                                          </div>
                                        )}
                                    </CardContent>
                                  </Card>
                                  {/* dfsd */}
                                </Grid>
                              ))}
                            </Grid>
                          </>
                        )}
                      </>
                    )}
                  </Box>
                </Grid>

                <Grid item xs={12} sx={{ marginTop: '15px' }}>
                  <Typography className='typography-message'>
                    <StarSymbol>*</StarSymbol> For special requests or
                    unavailable dates, call our customer care @ +91-7 44 888 77
                    11.
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Typography className='typography-message'>
                    <StarSymbol>*</StarSymbol> Each service covers assistance
                    for one guest and up to three bags, regardless of the total
                    number of passengers or bags. Infants aged 0-2 years are
                    complimentary, while children aged 2-12 years receive a 30%
                    discount on the adult rate.
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Typography className='typography-message'>
                    <StarSymbol>*</StarSymbol> For additional services related
                    to children, please ensure you book the necessary number of
                    services.
                  </Typography>
                </Grid>

                <Grid item xs={12} sx={{ marginTop: '20px' }}>
                  <Button
                    variant='contained'
                    onClick={addFamilyMemberModalOpen}
                    className='add-address-button'
                    sx={{ backgroundColor: '#FF5733', color: '#fff' }}
                  >
                    Add Passenger Detail
                  </Button>
                  <Modal
                    open={familyMemberOpen}
                    onClose={addFamilyMemberModalClose}
                    aria-labelledby='modal-modal-title'
                    aria-describedby='modal-modal-description'
                  >
                    <Box
                      className='booking-modal'
                      onClick={(e) => e.stopPropagation()}
                    >
                      <BookingAddFamilyMember
                        customerNo={
                          customerId ||
                          form1Value?.customerDetails?.id ||
                          user.customer_id
                        }
                        addFamilyMemberModalClose={addFamilyMemberModalClose}
                        isInternational={isInternationalService}
                      />
                    </Box>
                  </Modal>
                </Grid>
              </Box>
            </Grid>
            {/* Navigation Buttons */}
            <Grid item xs={12}>
              <Box className='button-passenger-container'>
                <CustomButton
                  variant='contained'
                  className='cancel-button'
                  type='button'
                  text={'back'}
                  state1={form1Value}
                  state2={formValuess}
                  state3={form3Value}
                  link={INSTANT_BOOKING_AIRPORT_DETAILS}
                />

                <CustomButton
                  variant='contained'
                  className='success-button'
                  type='Submit'
                  onClick={() => {
                    dispatch(resetBookingDetails());
                  }}
                  text={'Submit'}
                />
              </Box>
            </Grid>
          </Grid>
        </form>
      </Box>
    </>
  );
};
export default Form2;